
import Vue from 'vue'
import Component from 'vue-class-component'
import { INotificationService } from '../services/NotificationService'
import UserService from '@/services/UserService'
import ErrorHandlerService from '@/services/ErrorHandlerService'

import GreenButton from '../components/Atomic/GreenButton.vue'
import RedButton from '../components/Atomic/RedButton.vue'
import CardTitle from '../components/Atomic/CardTitle.vue'

@Component({
  components: {
    CardTitle,
    GreenButton,
    RedButton,
  },
})
export default class LoginRecovery extends Vue {
  private password: string = ''
  private username: string = ''
  private tokenKey!: string

  private isPending: boolean = false
  private $notificationService: INotificationService = {} as any
  private errorHandlerService: ErrorHandlerService = new ErrorHandlerService()

  private created() {
    this.tokenKey = this.$route.query.key as string
  }

  public get hasUser() {
    return this.username.length > 0
  }

  private cancel() {
    this.$router.push('/login')
  }

  private async confirm() {
    this.isPending = true

    const validated = await this.$validator.validateAll()
    if (validated) {
      try {
        const response = await UserService.loginRecovery(
          this.tokenKey,
          this.password,
        )
        this.username = response
      } catch (error: any) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
      } finally {
        this.isPending = false
      }
    }
    this.isPending = false
  }
}
